/**
 * 이 브라우저가 사이트 데이터(localStorage)를 쓸 수 있는가.
 *
 * 크롬 «사이트 데이터 저장 차단» · 파이어폭스 «모든 쿠키 차단» 에서는 `localStorage` 에 닿는
 * 순간 SecurityError 가 난다. 세션을 거기 두는 구조라 그런 브라우저에서는 **로그인이 원래
 * 안 된다** — 그 사실을 먼저 말해야 한다. 말하지 않으면 사람은 «잠시 후 다시 시도» 를
 * 끝없이 본다(2026-09-23 공격 시험 f1-9).
 */
export function storageAvailable(): boolean {
  try {
    const probe = "__storage_probe__";
    window.localStorage.setItem(probe, "1");
    window.localStorage.removeItem(probe);
    return true;
  } catch {
    return false;
  }
}

/** 읽을 수 없으면 null. 요청 인터셉터처럼 **던지면 모든 요청이 죽는** 자리에서 쓴다. */
export function readStorage(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

/** 지울 수 없으면 조용히 넘어간다. */
export function removeStorage(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    /* 차단된 브라우저 — 지울 것도 없다 */
  }
}
